import React from 'react';

interface CurvedArrowProps {
  className?: string;
  text: string;
  direction?: 'left' | 'right';
  style?: React.CSSProperties;
}

export function CurvedArrow({ className = '', text, direction = 'left', style }: CurvedArrowProps) {
  const pathD = direction === 'left'
    ? "M50,55 C40,40 25,35 10,35 L16,28 M10,35 L16,42"
    : "M50,55 C60,40 75,35 90,35 L84,28 M90,35 L84,42";

  const textClasses = direction === 'left' 
    ? "text-right mr-4 rotate-12" 
    : "text-left ml-4 -rotate-12";

  return (
    <div 
      className={`${className} text-text-secondary-light dark:text-text-secondary-dark hover:text-primary-light dark:hover:text-primary-dark transition-colors duration-300`}
      style={style}
    >
      <svg width="100" height="60" className="w-28 h-16">
        <path
          d={pathD}
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="animate-draw"
        />
      </svg>
      <span className={`text-sm font-medium ${textClasses} block mt-2`}>{text}</span>
    </div>
  );
}